/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import { Checkbox } from '@material-ui/core';
import { HeaderCheckBoxSelectListElement } from './HeaderCheckBoxSelectList';

interface HeaderCheckBoxElementProps {
    handleChange(checked: boolean, value: number): void;

    selected: Array<number>;
    value: HeaderCheckBoxSelectListElement;
}

interface HeaderCheckBoxElementState {
    checked: boolean;
    value: number;
}

class HeaderCheckBoxElement extends PureComponent<HeaderCheckBoxElementProps, HeaderCheckBoxElementState> {
    constructor(props: HeaderCheckBoxElementProps, context: HeaderCheckBoxElementState) {
        super(props, context);

        this.state = {
            checked: props.selected.indexOf(props.value.value) > -1,
            value: props.value.value,
        };
    }

    handleChange = (): void => {
        const { handleChange } = this.props;
        const { checked } = this.state;
        this.setState(
            {
                checked: !checked,
            },
            () => {
                handleChange(this.state.checked, this.state.value);
            }
        );
    };

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { checked } = this.state;
        return (
            <Checkbox
                checked={checked}
                style={{ padding: '0px' }}
                onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
                    this.handleChange();
                }}
            />
        );
    }
}

export default compose<any, any>(withStyles(adescomStyle))(HeaderCheckBoxElement);
